import Vue from 'vue'
/* eslint-disable */
/* eslint-disable no-new */
Vue.config.productionTip = false
var AWS_FULL_REGIONAL_SERVICES_LIST;
var AWS_SERVICES_LIST = [];
var AWS_REGIONS_LIST = [];
var AWS_SERVICES_MATRIX = {};

/* Dict of AWS Regions and their locations */
var AWS_REGION_LOCATIONS = {
  "us-east-1": "northern virginia",
  "us-east-2": "ohio",
  "us-west-1": "northern california",
  "us-west-2": "oregon",
  "af-south-1": "cape town",
  "ca-central-1": "canada central",
  "eu-central-1": "frankfurt",
  "eu-south-1": "milan",
  "eu-west-1": "ireland",
  "eu-west-2": "london",
  "eu-west-3": "paris",
  "eu-north-1": "stockholm",
  "me-south-1": "middle east bahrain",
  "ap-east-1": "hong kong",
  "ap-northeast-1": "tokyo",
  "ap-northeast-2": "seoul",
  "ap-northeast-3": "osaka",
  "ap-southeast-1": "singapore",
  "ap-southeast-2": "sydney",
  "ap-south-1": "mumbai",
  "sa-east-1": "sao paulo",
  "us-gov-west-1": "us gov west 1",
  "us-gov-east-1": "us gov east 1"
};


window.onload = function() {
  let url = "https://api.regional-table.region-services.aws.a2z.com/index.json";
  let xmlHttp = new XMLHttpRequest();
  xmlHttp.open( "GET", url, false );
  xmlHttp.send( null );

  /* Parse AWS Regional Services List*/
  AWS_FULL_REGIONAL_SERVICES_LIST = JSON.stringify(JSON.parse(xmlHttp.responseText).prices);
  AWS_FULL_REGIONAL_SERVICES_LIST = AWS_FULL_REGIONAL_SERVICES_LIST.replace(/\"aws:region\"/g, "\"region\"");
  AWS_FULL_REGIONAL_SERVICES_LIST = AWS_FULL_REGIONAL_SERVICES_LIST.replace(/\"aws:serviceName\"/g, "\"serviceName\"");
  AWS_FULL_REGIONAL_SERVICES_LIST = AWS_FULL_REGIONAL_SERVICES_LIST.replace(/\"aws:serviceUrl\"/g, "\"serviceUrl\"");
  AWS_FULL_REGIONAL_SERVICES_LIST = JSON.parse(AWS_FULL_REGIONAL_SERVICES_LIST);

  /* Populate list of AWS services and AWS regions*/
  for (let i = 0; i < AWS_FULL_REGIONAL_SERVICES_LIST.length; i++) {
    if (!AWS_SERVICES_LIST.includes(AWS_FULL_REGIONAL_SERVICES_LIST[i].attributes.serviceName)) {
      AWS_SERVICES_LIST.push(AWS_FULL_REGIONAL_SERVICES_LIST[i].attributes.serviceName);
    }
    if (!AWS_REGIONS_LIST.includes(AWS_FULL_REGIONAL_SERVICES_LIST[i].attributes.region)) {
      AWS_REGIONS_LIST.push(AWS_FULL_REGIONAL_SERVICES_LIST[i].attributes.region);
    }
  }

  /* Sort AWS Services/Regions List Alphabetically */
  AWS_REGIONS_LIST = AWS_REGIONS_LIST.sort();
  AWS_SERVICES_LIST = AWS_SERVICES_LIST.sort(function(a, b) {
    a = a.replace("AWS ", "");
    a = a.replace("Amazon ", "");
    b = b.replace("AWS ", "");
    b = b.replace("Amazon ", "");
    if (a.toLowerCase() > b.toLowerCase()) {
      return 1;
    } else {
      return -1;
    }
  });

  /* Populate AWS Services and Regions json object */
  for (let j = 0; j < AWS_REGIONS_LIST.length; j++) {
    AWS_SERVICES_MATRIX[AWS_REGIONS_LIST[j]] = {};
  }
  for (let i = 0; i < AWS_FULL_REGIONAL_SERVICES_LIST.length; i++) {
    AWS_SERVICES_MATRIX[AWS_FULL_REGIONAL_SERVICES_LIST[i].attributes.region][AWS_FULL_REGIONAL_SERVICES_LIST[i].attributes.serviceName] = true;
  }
};

/* Vue instance to display AWS Services Page*/
new Vue({
  el: '#AWS_Services',
  data: {
    AwsRegionsServicesFullList: AWS_FULL_REGIONAL_SERVICES_LIST,  // complete data structure holding all information
    AwsServicesList: AWS_SERVICES_LIST,       // complete list of AWS services
    AwsRegionsList: AWS_REGIONS_LIST,         // complete list of AWS regions
    AwsMatrix: AWS_SERVICES_MATRIX,           // holds values for whether a service is in a region
    SelectedRegionsList: AWS_REGIONS_LIST,    // holds list of selected regions
    RegexRegionsList: AWS_REGIONS_LIST,       // holds regions list from regex
    SelectedServicesList: null,                // list of services selected from regex
    allServicesList: null,       // list of all services for Show all regions
    allRegionsList: null,                     // list of services that are in all regions
    notRegionsList: null,                     // list of services that are not in all regions
    serviceOption: null,                      // service input text
    regionOption: null,                       // region input text
    radioButtonOption: 'allServices',         // dropdown menu option
    isGovSelected: true,                      // hide/show government regions selector
    serviceOrderValue: true,                  // toggle for asc/desc order of services
    regionOrderValue: true,                   // toggle for asc/desc order of regions
    regionHolder: null                        // holds last region selected for region column sorting
  },
  methods: {
    /* calls functions to update table */
    updateTable: function() {
      this.updateRegionOption();
      this.pushPopGovRegions();
      this.updateServiceOption();
      this.router();
      this.setQueryParams();
    },
    /* regex for region selector */
    updateRegionOption(){
      if (this.regionOption) {
        this.RegexRegionsList = [];
        const pattern = new RegExp(this.regionOption);
        for (var i = 0; i < this.AwsRegionsList.length; i++) {
          if (pattern.exec(this.AwsRegionsList[i]) || pattern.exec(AWS_REGION_LOCATIONS[this.AwsRegionsList[i]])){
            this.RegexRegionsList.push(this.AwsRegionsList[i]);
          }
        }
        console.log("Regex regions list: " + this.RegexRegionsList);
      } else {
        this.RegexRegionsList = this.AwsRegionsList.slice();
        console.log("Regex regions list: " + this.RegexRegionsList);
      }
    },
    /* pushes or pops gov regions from selected regions list */
    pushPopGovRegions: function() {
      this.SelectedRegionsList = this.RegexRegionsList;
      if (this.isGovSelected) {
        if (this.RegexRegionsList.includes('us-gov-east-1')) {
          this.SelectedRegionsList = this.SelectedRegionsList.filter(function(input) {
            return input != 'us-gov-east-1';
          });
        }
        if (this.RegexRegionsList.includes('us-gov-west-1')) {
          this.SelectedRegionsList = this.SelectedRegionsList.filter(function(input) {
            return input != 'us-gov-west-1';
          });
        }
      } else {
        if (!this.SelectedRegionsList.includes('us-gov-east-1') && this.RegexRegionsList.includes('us-gov-east-1')) {
          this.SelectedRegionsList.push('us-gov-east-1');
        }
        if (!this.SelectedRegionsList.includes('us-gov-west-1') && this.RegexRegionsList.includes('us-gov-west-1')) {
          this.SelectedRegionsList.push('us-gov-west-1');
        }
      }
      console.log("RegexRegionsList " + this.RegexRegionsList);
      console.log("SelectedRegionsList " + this.SelectedRegionsList);
    },
    /* Regex for service selector */
    updateServiceOption(){
      this.SelectedServicesList = [];
      if (this.serviceOption) {
        const pattern = new RegExp(this.serviceOption.toLowerCase());
        for(var i = 0; i < this.AwsServicesList.length; i++){
          if(pattern.exec(this.AwsServicesList[i].toLowerCase())){
            this.SelectedServicesList.push(this.AwsServicesList[i]);
          }
        }
        console.log("SelectedServices in updateServiceOption: " + this.SelectedServicesList);
      } else {
        this.SelectedServicesList = this.AwsServicesList.slice();
      }
    },
    router: function() {
      if (this.radioButtonOption == 'allServices') {
        this.allServicesMethod();
      } else if (this.radioButtonOption == 'allRegions') {
        this.allRegionsMethod();
      } else if (this.radioButtonOption == 'notRegions') {
        this.notRegionsMethod();
      }
    },
    /* copies selected services to allServicesList */
    allServicesMethod: function() {
      this.allServicesList = this.SelectedServicesList.slice();
    },
    /* Builds list of services that are available in all of the selected regions*/
    allRegionsMethod: function() {
      this.radioButtonOption = "allRegions";
      this.allRegionsList = [];

      for (let i = 0; i < this.SelectedServicesList.length; i++) {
        let isValid = true;
        for (let j = 0; j < this.SelectedRegionsList.length; j++) {
          if (!this.AwsMatrix[this.SelectedRegionsList[j]][this.SelectedServicesList[i]]){
            isValid = false;
          }
        }
        if (isValid) {
          this.allRegionsList.push(this.SelectedServicesList[i]);
        }
      }
      console.log("AllRegionsList: " + this.allRegionsList);
    },
    /* Builds list of services that are not available in at least one of the selected region*/
    notRegionsMethod: function() {
      this.radioButtonOption = "notRegions";
      this.notRegionsList = [];

      console.log("global " + AWS_SERVICES_LIST);
      console.log("selected " + this.SelectedServicesList);
      for (let i = 0; i < this.SelectedServicesList.length; i++) {
        let isValid = true;
        for (let j = 0; j < this.SelectedRegionsList.length; j++) {
          if (!this.AwsMatrix[this.SelectedRegionsList[j]][this.SelectedServicesList[i]]){
            isValid = false;
          }
        }
        if (!isValid) {
          this.notRegionsList.push(this.SelectedServicesList[i]);
        }
      }
      console.log("Not regions list = " + this.notRegionsList);
    },
    /* Watches Clear Services checkbox and updates */
    clearText: function(event){
      this.SelectedServicesList = this.AwsServicesList.slice();
      this.serviceOption = '';
      this.SelectedRegionsList = this.AwsRegionsList.slice();
      this.regionOption = '';
    },
    /* changes order of services to ascending or descending */
    reverseServiceOrder: function() {
      try {
        this.allServicesList = this.allServicesList.reverse();
      } catch(error) {
        console.log(error);
      }
      try {
        this.allRegionsList = this.allRegionsList.reverse();
      } catch(error) {
        console.log(error);
      }
      try {
        this.notRegionsList = this.notRegionsList.reverse();
      } catch(error) {
        console.log(error);
      }
      this.serviceOrderValue ? this.serviceOrderValue = false : this.serviceOrderValue = true;
    },
    /* changes order of regions to ascending or descending */
    reverseRegionOrder: function() {
      try {
        this.SelectedRegionsList = this.SelectedRegionsList.reverse();
      } catch(error) {
        console.log(error);
      }
      this.regionOrderValue ? this.regionOrderValue = false : this.regionOrderValue = true;
    },

    /* Set Query String parameters after each update */
    setQueryParams(){
      let urlObj = new URL(window.location.href); // javascript url object that we can use to handle query strings
      urlObj.searchParams.set("regionOption", this.regionOption);
      urlObj.searchParams.set("serviceOption", this.serviceOption);
      urlObj.searchParams.set("radioButtonOption", this.radioButtonOption);
      urlObj.searchParams.set("hideGov", this.isGovSelected);

      let params = urlObj.searchParams;
      window.history.replaceState({}, '', '/?' + params);
    },
    /* Get Query String parameters and populate data section */
    getQueryParams(){
      let urlObj = new URL(window.location.href); // javascript url object that we can use to handle query strings
      let regionParam = urlObj.searchParams.get("regionOption");
      let serviceParam = urlObj.searchParams.get("serviceOption");
      let radioParam = urlObj.searchParams.get("radioButtonOption");
      let govParam = urlObj.searchParams.get("hideGov");

      this.regionOption = regionParam;
      this.serviceOption = serviceParam;
      if(radioParam == 'allServices' || radioParam == 'allRegions' || radioParam == 'notRegions'){
        this.radioButtonOption = radioParam;
      }
      if (govParam == 'false') {
        this.isGovSelected = false;
      } else {
        this.isGovSelected = true;
      }
    },
    /* Sort region column by availability */
    sortByRegionColumn(region) {
      if (this.radioButtonOption == 'allServices' && this.regionHolder != region) {
        this.allServicesList = this.allServicesList.sort(function(a, b) {
          if (AWS_SERVICES_MATRIX[region][a] && AWS_SERVICES_MATRIX[region][b]) {
            a = a.replace("AWS ", "");
            a = a.replace("Amazon ", "");
            b = b.replace("AWS ", "");
            b = b.replace("Amazon ", "");
            if (a.toLowerCase() > b.toLowerCase()) {
              return 1;
            } else {
              return -1;
            }
          } else if (AWS_SERVICES_MATRIX[region][a]) {
            return -1;
          } else if (AWS_SERVICES_MATRIX[region][b]) {
            return 1;
          } else {
            a = a.replace("AWS ", "");
            a = a.replace("Amazon ", "");
            b = b.replace("AWS ", "");
            b = b.replace("Amazon ", "");
            if (a.toLowerCase() > b.toLowerCase()) {
              return 1;
            } else {
              return -1;
            }
          }
        });
        this.regionHolder = region;
        console.log(this.allServicesList);
      } else if (this.radioButtonOption == 'allServices' && this.regionHolder == region) {
        this.allServicesList = this.allServicesList.sort(function(a, b) {
          if (AWS_SERVICES_MATRIX[region][a] && AWS_SERVICES_MATRIX[region][b]) {
            a = a.replace("AWS ", "");
            a = a.replace("Amazon ", "");
            b = b.replace("AWS ", "");
            b = b.replace("Amazon ", "");
            if (a.toLowerCase() > b.toLowerCase()) {
              return 1;
            } else {
              return -1;
            }
          } else if (AWS_SERVICES_MATRIX[region][a]) {
            return 1;
          } else if (AWS_SERVICES_MATRIX[region][b]) {
            return -1;
          } else {
            a = a.replace("AWS ", "");
            a = a.replace("Amazon ", "");
            b = b.replace("AWS ", "");
            b = b.replace("Amazon ", "");
            if (a.toLowerCase() > b.toLowerCase()) {
              return 1;
            } else {
              return -1;
            }
          }
        });
        this.regionHolder = null;
      } else if (this.radioButtonOption == 'notRegions' && this.regionHolder != region) {
        this.notRegionsList = this.notRegionsList.sort(function(a, b) {
          if (AWS_SERVICES_MATRIX[region][a] && AWS_SERVICES_MATRIX[region][b]) {
            a = a.replace("AWS ", "");
            a = a.replace("Amazon ", "");
            b = b.replace("AWS ", "");
            b = b.replace("Amazon ", "");
            if (a.toLowerCase() > b.toLowerCase()) {
              return 1;
            } else {
              return -1;
            }
          } else if (AWS_SERVICES_MATRIX[region][a]) {
            return -1;
          } else if (AWS_SERVICES_MATRIX[region][b]) {
            return 1;
          } else {
            a = a.replace("AWS ", "");
            a = a.replace("Amazon ", "");
            b = b.replace("AWS ", "");
            b = b.replace("Amazon ", "");
            if (a.toLowerCase() > b.toLowerCase()) {
              return 1;
            } else {
              return -1;
            }
          }
        });
        this.regionHolder = region;
      } else if (this.radioButtonOption == 'notRegions' && this.regionHolder == region) {
        this.notRegionsList = this.notRegionsList.sort(function(a, b) {
          if (AWS_SERVICES_MATRIX[region][a] && AWS_SERVICES_MATRIX[region][b]) {
            a = a.replace("AWS ", "");
            a = a.replace("Amazon ", "");
            b = b.replace("AWS ", "");
            b = b.replace("Amazon ", "");
            if (a.toLowerCase() > b.toLowerCase()) {
              return 1;
            } else {
              return -1;
            }
          } else if (AWS_SERVICES_MATRIX[region][a]) {
            return 1;
          } else if (AWS_SERVICES_MATRIX[region][b]) {
            return -1;
          } else {
            a = a.replace("AWS ", "");
            a = a.replace("Amazon ", "");
            b = b.replace("AWS ", "");
            b = b.replace("Amazon ", "");
            if (a.toLowerCase() > b.toLowerCase()) {
              return 1;
            } else {
              return -1;
            }
          }
        });
        this.regionHolder = null;
      }
    }
  },
  watch: {
    /* Watches serviceOption input and updates*/
    serviceOption: function() {
      this.updateTable();
    },
    /* Watches regionOption input and updates*/
    regionOption: function() {
      this.updateTable();
    },
    /* Watches gov checkbox and updates */
    isGovSelected: function() {
      this.updateTable();
    },
    /* set query string params when radio button option is changed */
    radioButtonOption: function() {
      console.log("radiobutton");
      this.updateTable();
      this.regionHolder = null;
      this.regionOrderValue = true;
    }
  },
  mounted: function(){
    window.addEventListener('load', () => {
      this.getQueryParams();
      this.updateTable();
    })
  }
})


// WEBPACK FOOTER //
// ./src/main.js